export default __webpack_public_path__ + "static/media/icon_privacy_overview_step2.b3190b92.svg";